module.exports = __webpack_public_path__ + "static/media/musicadjudicator_email.17bfb294.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/musicadjudicator_email.svg
// module id = 962
// module chunks = 0